import { ValidationArguments, ValidatorConstraint, ValidatorConstraintInterface } from "class-validator";
import type { Attribute } from './Attribute';
import { AttributeOption } from "./AttributeOption";
import { PaymentPlan } from './PaymentPlan';
import type { Policy } from './Policy';

@ValidatorConstraint({
    name: "DownPaymentAttributeValidator",
    async: false,
})
export class DownPaymentAttributeValidator implements ValidatorConstraintInterface {
    errorType: "missing" | "invalid" = "invalid";
    validate(value: Attribute[], _args: ValidationArguments): boolean {
        const policy = _args.object as Policy;
        const hasDownPaymentAttribute = value.some((a) => a.attributeOptionId === AttributeOption.Id.DOWN_PAYMENT_AMOUNT);
        if (!hasDownPaymentAttribute && PaymentPlan.includesDownPayment(policy.paymentPlanId)) {
            this.errorType = "missing";
            return false;
        }

        try {
            for (const a of value) {
                if (a.attributeOptionId === AttributeOption.Id.DOWN_PAYMENT_AMOUNT) {
                    if (typeof a.valueNumber !== "number") {
                        this.errorType = "invalid";
                        return false;
                    }
                }
            }
        } catch (e: unknown) {
            return false;
        }

        return true;
    }

    defaultMessage(_args: ValidationArguments): string {
        const policy = _args.object as Policy;

        if (this.errorType === "missing") {
            return `Down payment attribute is required for payment plan: ${PaymentPlan.getTypeById(policy.paymentPlanId)}`;
        }
        return "Invalid down payment attribute amount";
    }
}

@ValidatorConstraint({
    name: "EscrowDepositAttributeValidator",
    async: false,
})
export class EscrowDepositAttributeValidator implements ValidatorConstraintInterface {
    validate(value: Attribute[], _args: ValidationArguments): boolean {
        try {
            for (const a of value) {
                if (a.attributeOptionId === AttributeOption.Id.ESCROW_DEPOSIT_AMOUNT) {
                    if (typeof a.valueNumber !== "number") {
                        return false;
                    }
                }
            }
        } catch (e: unknown) {
            return false;
        }

        return true;
    }

    defaultMessage(_args: ValidationArguments): string {
        return "Invalid escrow deposit attribute amount";
    }
}